// Monarch application routing
export enum AppPath {
	Home = '/',
	Reward = '/rewards/{id}',
	Rewards = '/rewards',
}

// Monolith application routing
export enum Route {
	AdminBilling = '/company/billing',
	Balance = '/company/users/{id}/show_give_balance',
	Hashtags = '/company/hashtags/{id}',
	History = '/company/accounts/{id}',
	Login = '/users/sign_in_start',
	PendingAwards = '/awards/approval_requests',
	Rewards = '/company/rewards/new',
	UserProfile = '/company/users/{id}',
}

// External pages
export enum Page {
	Contact = 'https://bonus.ly/contact',
	Help = 'https://help.bonus.ly/en/',
	NewFeatures = 'https://help.bonus.ly/en/articles/4076250-product-updates-and-new-features',
	PrivacyPolicy = 'https://bonus.ly/privacy_policy',
	Status = 'https://status.bonus.ly/',
	TermsOfService = 'https://bonus.ly/terms_of_service',
	OfficeHoursRegistrationLink = 'https://calendly.com/bonusly-expert-office-hours',
	CsOfficeHours = 'https://help.bonus.ly/en/articles/13170767-bonusly-office-hours',
	TalkWithSales = 'https://bonusly.chilipiper.com/round-robin/free-trial-to-demo',
	AndroidApp = 'https://play.google.com/store/apps/details?id=ly.bonus.android',
	iOSApp = 'https://apps.apple.com/us/app/bonusly/id995249036',
}
